(() => {
  function init(root = document) {
    const menu = root.querySelector('.menu');
    const nav = root.querySelector('#navigation');
    if (menu && nav && !menu.dataset.ready) {
      menu.dataset.ready = 'true';
      const close = () => { nav.classList.remove('open'); menu.setAttribute('aria-expanded', 'false'); menu.setAttribute('aria-label', document.body.dataset.menuOpen); };
      menu.addEventListener('click', () => { const open = nav.classList.toggle('open'); menu.setAttribute('aria-expanded', String(open)); menu.setAttribute('aria-label', open ? document.body.dataset.menuClose : document.body.dataset.menuOpen); });
      nav.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
      menu.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
      nav.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); menu.focus(); } });
    }
    root.querySelectorAll('.filters').forEach(filters => {
      if (filters.dataset.ready) return;
      filters.dataset.ready = 'true';
      const scope = filters.closest('.work');
      filters.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
        filters.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        scope.querySelectorAll('.project').forEach(p => { p.hidden = button.dataset.filter !== 'all' && p.dataset.category !== button.dataset.filter; });
      }));
    });
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => {
    const card = e.target.closest('.project');
    if (card) {
      const work = card.closest('.work');
      const all = work.querySelector('[data-filter="all"]');
      if (all) all.click();
    }
  });
  const status = document.querySelector('[data-form-status]');
  if (status) { status.focus(); status.scrollIntoView({ block: 'center', behavior: 'instant' }); }
})();
// Prefill the real Shopify enquiry form from a quantity offer.
document.addEventListener('click', event => {
  const offer = event.target.closest('[data-cap-quantity]');
  if (!offer) return;
  const quantity = document.getElementById(offer.dataset.capForm === 'caps' ? 'CapsContactQuantity' : 'ContactQuantity');
  const service = document.getElementById(offer.dataset.capForm === 'caps' ? 'CapsContactService' : 'ContactService');
  if (quantity) quantity.value = offer.dataset.capQuantity;
  if (service && service.options.length > 2) service.selectedIndex = 2;
});

// Open the brochure for direct links, browser history and returned form errors.
(() => {
  function revealCaps() {
    const panel = document.getElementById('kepsar');
    if (!panel) return;
    const target = location.hash ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null;
    if ((target && (target === panel || panel.contains(target))) || panel.querySelector('[data-form-status]')) {
      panel.open = true;
      if (target) requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
      const status = panel.querySelector('[data-form-status]');
      if (status) { status.focus(); status.scrollIntoView({block:'center'}); }
    }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-open-caps]');
    if (link) { const panel = document.getElementById('kepsar'); if (panel) panel.open = true; }
  });
  window.addEventListener('hashchange', revealCaps);
  document.addEventListener('shopify:section:load', revealCaps);
  revealCaps();
})();

// Language uses Shopify localization; quote currency stays independent of it.
(() => {
  'use strict';
  const fx = window.BrandStudioCurrency;
  if (!fx) return;
  const storage = {
    get(key) { try { return localStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { localStorage.setItem(key, value); } catch (_) {} }
  };
  let selected = fx.currency(storage.get('brandstudio.currency'));
  let rates = null;
  let rateDate = '';
  let pending = null;
  function render() {
    if (!rates) return;
    document.querySelectorAll('[data-sek]').forEach(node => {
      node.textContent = fx.format(node.dataset.sek, selected, rates, document.documentElement.lang);
    });
    document.querySelectorAll('[data-currency-select]').forEach(select => { select.value = selected; });
    document.querySelectorAll('[data-contact-currency]').forEach(input => { input.value = selected; });
    document.querySelectorAll('[data-fx-note]').forEach(note => { note.hidden = selected === 'SEK'; });
    document.querySelectorAll('[data-fx-date]').forEach(time => { time.textContent = rateDate; time.dateTime = rateDate; });
  }
  function fallback(select) {
    return {SEK: 1, THB: fx.positive(select.dataset.rateThb) || 3.39279, USD: fx.positive(select.dataset.rateUsd) || 0.100827, EUR: fx.positive(select.dataset.rateEur) || 0.089904};
  }
  async function refresh() {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 7000);
    try {
      const entries = await Promise.all(['THB', 'USD', 'EUR'].map(async quote => {
        const response = await fetch('https://api.frankfurter.dev/v2/providers/ecb/rate/sek/' + quote.toLowerCase(), {signal: controller.signal, credentials: 'omit'});
        if (!response.ok) throw new Error('Exchange-rate service unavailable');
        return {quote, ...fx.liveRate(await response.json(), quote)};
      }));
      const next = {SEK: 1};
      entries.forEach(entry => { next[entry.quote] = entry.rate; });
      if (!fx.validRates(next)) throw new Error('Incomplete exchange rates');
      rates = next;
      rateDate = entries.map(entry => entry.date).sort()[0];
      storage.set('brandstudio.rates', JSON.stringify({rates, date: rateDate, savedAt: Date.now()}));
      render();
    } catch (_) {
      // Keep the dated reference or cached rates visible, including their date.
    } finally { clearTimeout(timeout); pending = null; }
  }
  function init() {
    const select = document.querySelector('[data-currency-select]');
    if (!select) return;
    if (!rates) {
      rates = fallback(select);
      rateDate = select.dataset.ratesDate;
      if (select.dataset.liveRates === 'true') {
        try {
          const cache = JSON.parse(storage.get('brandstudio.rates') || 'null');
          const age = Date.now() - Number(cache && cache.savedAt);
          if (cache && age >= 0 && age < 7 * 86400000 && /^\d{4}-\d{2}-\d{2}$/.test(cache.date) && fx.validRates(cache.rates)) {
            rates = cache.rates; rateDate = cache.date;
          }
        } catch (_) {}
      }
    }
    select.disabled = false;
    if (!select.dataset.bound) {
      select.dataset.bound = 'true';
      select.addEventListener('change', () => {
        selected = fx.currency(select.value);
        storage.set('brandstudio.currency', selected);
        render();
      });
    }
    document.querySelectorAll('[data-language-select]').forEach(language => {
      if (language.dataset.bound) return;
      language.dataset.bound = 'true';
      language.addEventListener('change', () => { storage.set('brandstudio.currency', selected); language.form.requestSubmit(); });
    });
    render();
    if (select.dataset.liveRates === 'true' && !pending) {
      let fresh = false;
      try { const cache = JSON.parse(storage.get('brandstudio.rates') || 'null'); const age = Date.now() - Number(cache && cache.savedAt); fresh = cache && fx.validRates(cache.rates) && age >= 0 && age < 12 * 3600000; } catch (_) {}
      if (!fresh) pending = refresh();
    }
  }
  document.addEventListener('submit', event => {
    const input = event.target.querySelector('[data-contact-currency]');
    if (input) input.value = selected;
  });
  document.addEventListener('shopify:section:load', init);
  init();
})();
